import { Factory, trait } from 'miragejs';

export default Factory.extend({
  asAssistance: trait({
    afterCreate(deviceConfigStaticPage, server) {
      deviceConfigStaticPage.update({ type: 'PropertyAssistanceScreens' });

      server.create('device-config-static-page-attribute', {
        deviceConfigStaticPage,
        kind: 'message',
        message: 'assistance page',
        type: 'CustomPropertyAssistanceMessage',
      });
    },
  }),
  asWalkUp: trait({
    afterCreate(deviceConfigStaticPage, server) {
      deviceConfigStaticPage.update({ type: 'PropertyWalkUpFinalScreens' });

      server.create('device-config-static-page-attribute', {
        deviceConfigStaticPage,
        kind: 'message',
        message: 'walk up page',
        type: 'CustomPropertyFinalMessage',
      });
    },
  }),
  asInvited: trait({
    afterCreate(deviceConfigStaticPage, server) {
      deviceConfigStaticPage.update({ type: 'PropertyInvitedFinalScreens' });

      server.create('device-config-static-page-attribute', {
        deviceConfigStaticPage,
        kind: 'message',
        message: 'invited page',
        type: 'CustomPropertyFinalMessage',
      });
    },
  }),
});
